import request from '../request'

export default {
  getMediosAereos: function () {
    return request.get('planificacion_medios_aereos')
  },

  setVueltaAgoncillo: function (data) {
    return request.put(`set_vuelta_agoncillo/${data.ID_MEDIO_SECTOR}/${data.AGONCILLO}`)
  },

  addPeriodoDescanso: function (data) {
    return request.post('periodo_descanso/', data)
  }
}
